import axios from 'axios';
import { setBlockTracking } from 'vue';
import addresstypes from './addresstypes';
import { useRouteHelperStore } from '../../pinia/RouteHelperStore';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [
    ],
    loaded : false,
    addNew : false,
    workingOn: [],
})

  // getters
  const getters = {
    getConditions: (state) => (type) => {
        return state.list.filter(item => item.type == type);
    }
  }

  // actions
  const actions = {
    async destroyCondition({commit, state, rootState}, data){
      const RouteHelperStore = useRouteHelperStore();
      axios.delete(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/kooi/" + data.kooi_id + "/condition/" + data.item.id).then((response) => {
        commit("removeCondition", state.list.findIndex(item => item.id == data.item.id));
        var index = RouteHelperStore.initialState.findIndex(item => item.id ==  data.item.id);
        if(index >= 0){
          RouteHelperStore.initialState.splice(index, 1);
        }
      }).catch((error) => {
        console.log(error.response.status);
      });
    },

  }

  // mutations
  const mutations = {
      clearBlocks(state){
          state.list = [];
      },
      addBlock(state, blocks){
          if(blocks.type == undefined){
              blocks.type = "selling";
          }
          blocks.new = true;
          state.list.push(blocks);
      },
      updateCondition(state, condition){
        var index = state.list.findIndex(item => item.id == condition.id);
        if(index > -1){
          state.list[index] = condition;
        }
      },
      setBlock(state, data){
        state.list[data.index].data = data.data;
      },
      setBlockById(state, data){
        var index = state.list.findIndex(item => item.id == data.index);
        if(index >= 0){
          state.list[index].block.data = data.data;
        }
      },
      init(state, data){
          state.list = data;
      },
      removeCondition(state, index){
        state.list.splice(index, 1);
      },
      removeId(state, id){
        var index = state.list.findIndex(item => item.id == id);
        if(index >= 0){
            state.list.splice(index, 1);
        }
    },
      setSupplierConditions(state, companyInformations){
        for(let i = 0; i < companyInformations.length; i++){
            var tmp = {
                block : companyInformations[i].block,
                id : 0,
                name : companyInformations[i].name,
                type: "buying",
            };
            state.list.push(tmp);
        }
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
